import api from "../service";
import { middlewareResponse } from "utils";

export const update = async (form: FormData) => {
  await api.setToken();
  await api.setHeaderFormFiles();
  let isValid: any | null = await api
    .requestPut(`User`, form)
    .then(middlewareResponse);
  api.removeHeaderFormFiles();

  return isValid;
};

export const get = async () => {
  await api.setToken();
  let isValid: any | null = await api
    .requestGet(`User`)
    .then(middlewareResponse);
  return isValid;
};

export const create = async (form: FormData) => {
  await api.setToken();
  await api.setHeaderFormFiles();
  let isValid: any | null = await api
    .requestPost(`User`, form)
    .then(middlewareResponse);
  api.removeHeaderFormFiles();
  return isValid;
};

export const permissions = async (id: number, permissions: any) => {
  await api.setToken();
  let isValid: any | null = await api
    .requestPut(`User/permissions/${id}`, permissions)
    .then(middlewareResponse);
  return isValid;
};

export const setThemeMode = async (mode: string) => {
  await api.setToken();
  let isValid: any | null = await api
    .requestPut(`User/ThemeMode?modo=${mode}`, null)
    .then(middlewareResponse);
  return isValid;
};
